// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { INVOICE_ACCESS_DEFAULT, InvoiceAccessModel } from './invoice-access.model';

@State({ name: 'InvoiceAccess' })
@Injectable()
export class InvoiceAccessState {

  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateInvoicesAccess(roles: PermissionEnum[], user: UserModel): InvoiceAccessModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: InvoiceAccessModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): InvoiceAccessModel {
    switch (role) {
      case PermissionEnum.CAN_READ_INVOICES:
        return {
          ...INVOICE_ACCESS_DEFAULT,
          canReadInvoices: true
        };
      case PermissionEnum.CAN_READ_INVOICE_BY_ID:
        return {
          ...INVOICE_ACCESS_DEFAULT,
          canReadInvoiceById: true
        };
      case PermissionEnum.CAN_WRITE_INVOICES:
        return {
          ...INVOICE_ACCESS_DEFAULT,
          canWriteInvoices: true
        };
      case PermissionEnum.CAN_WRITE_RECEIPT_OF_INVOICE:
        return {
          ...INVOICE_ACCESS_DEFAULT,
          canWriteReceiptOfInvoice: true
        };
        case PermissionEnum.CAN_REDA_RECEIPT_OF_INVOICE:
        return {
          ...INVOICE_ACCESS_DEFAULT,
          canReadReceiptOfInvoice: true
        };

      case PermissionEnum.SUPER_USER:
        return {
          canReadInvoiceById: true,
          canReadInvoices: true,
          canWriteInvoices: true,
          canRemoveTemplate: true,
          canSaveForce: true,
          canWriteReceiptOfInvoice: true,
          canReadReceiptOfInvoice: true,
        };
      default: {
        return {
          ...INVOICE_ACCESS_DEFAULT
        };
      }
    }
  }


  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: InvoiceAccessModel[]): InvoiceAccessModel {
    const moduleConfig: InvoiceAccessModel = INVOICE_ACCESS_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canReadInvoices = moduleConfig.canReadInvoices ? true : config.canReadInvoices;
      moduleConfig.canReadInvoiceById = moduleConfig.canReadInvoiceById ? true : config.canReadInvoiceById;
      moduleConfig.canWriteInvoices = moduleConfig.canWriteInvoices ? true : config.canWriteInvoices;
      moduleConfig.canRemoveTemplate = moduleConfig.canRemoveTemplate ? true : config.canRemoveTemplate;
      moduleConfig.canSaveForce = moduleConfig.canSaveForce ? true : config.canSaveForce;
      moduleConfig.canWriteReceiptOfInvoice = moduleConfig.canWriteReceiptOfInvoice ? true : config.canWriteReceiptOfInvoice;
      moduleConfig.canReadReceiptOfInvoice = moduleConfig.canReadReceiptOfInvoice ? true : config.canReadReceiptOfInvoice;
    }

    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToInvoices(profileState: ProfileStateModel, accessState: AccessStateModel): InvoiceAccessModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return InvoiceAccessState.generateInvoicesAccess(roleList, userData);
  }

}


